<div
  class="card mb-5 stack-bar-card"
  [class.stack-bar-card-with-arrow]="showConnectorArrow"
  [style.margin-left]="data.marginleft"
  *ngIf="data"
>
  <div class="card-header stack-bar-card-header">
    <div class="card-title d-flex flex-column w-100 text-center">
      <h4>{{ data.title }}</h4>
    </div>
  </div>
  <div class="card-body">
    <div class="stack-bar-chart-wrap">
      <div
        class="chart-scale-wrap"
        [style.transform]="data.chartConfig?.wrapperScale ? 'scale(' + data.chartConfig.wrapperScale + ')' : null"
        [style.transformOrigin]="data.chartConfig?.wrapperScale ? 'top left' : null"
        [style.width]="data.chartConfig?.wrapperScale ? (100 / data.chartConfig.wrapperScale) + '%' : null"
      >
        <div
          class="stack-bar-chart-host"
          [id]="data.widgetId"
          [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'"
          style="width: 100%"
        ></div>
      </div>
    </div>
  </div>
</div>
